export default __webpack_public_path__ + "static/media/space_adventure.d278fa0a.png";